import { Button, styled } from "@mui/material";

export const BtnSelect = styled(Button)(({ theme }) => ({
  color: "white",
  border: "0",
  minHeight: "40px",
  minWidth: "150px",
  boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.16)",
  cursor: "pointer",
  marginTop: "20px",
  borderRadius: "0px 4px 4px 0px",
  [theme.breakpoints.down("md")]: {},
}));

export const BtnLogin = styled(Button)({
  backgroundColor: "#4daf51 !important",
  textTransform: "none",
  color: "white",
  marginTop: "50px",
});
